import ChatSDK from 'test-iso-chat-sdk';

export const getGroupcast = async ({ ids, customType, searchTag, sortByCustomType, limit, skip, sort, executionPending } = {}) => {
  const params = {};

  if (ids) params.ids = ids;
  if (customType) params.customType = customType;
  if (searchTag) params.searchTag = searchTag;
  if (sortByCustomType) params.sortByCustomType = sortByCustomType;
  if (limit) params.limit = limit;
  if (skip) params.skip = skip;
  if (sort) params.sort = sort;
  if (executionPending) params.executionPending = executionPending;

  const res = await ChatSDK.getInstance().groupcast.getGroupCasts(params);
  return res;
};

export const postGroupCast = async ({ groupcastTitle, groupcastImageUrl, members, searchableTags, metaData, customType }) => {
  const res = await ChatSDK.getInstance().groupcast.postGroupCast({
    groupcastTitle,
    groupcastImageUrl,
    members,
    searchableTags,
    metaData,
    customType,
  });

  return res;
};

export const getGroupcastMessage = async groupcastId => {
  const res = await ChatSDK.getInstance().groupcast.getGroupCastMessages({
    groupcastId: groupcastId,
  });
  return res;
};

export const postGroupCastMessage = async params => {
  /*
    Expected params:
    {
      showInConversation: true/false,
      sendPushForNewConversationCreated: true/false,
      searchableTags: [ 'tag1', 'tag2' ],
      readCount: number,
      parentMessageId: 'optional-string',
      notifyOnCompletion: true/false,
      notificationTitle: 'optional-string',
      notificationBody: 'optional-string',
      metaData: { key: value },
      messageType: number,
      mentionedUsers: [
        {
          userId: 'string',
          startIndex: number,
          endIndex: number
        }
      ],
      hideNewConversationsForSender: true/false,
      groupcastId: 'string',
      events: {
        onDelivered: true/false,
        onSeen: true/false
      },
      encrypted: true/false,
      deviceId: 'string',
      deliveryCount: number,
      customType: 'optional-string',
      body: 'string',
      attachments: [
        {
          fileUrl: 'string',
          fileName: 'string',
          fileType: 'string'
        }
      ]
    }
  */

  const res = await ChatSDK.getInstance().groupcast.postGroupCastMessage(params);
  return res;
};

export const deleteGroupCast = async groupcastId => {
  const res = await ChatSDK.getInstance().groupcast.deleteGroupCastConversation({
    groupcastId: groupcastId,
  });
  return res;
};

export const getGroupcastEligibleMembers = async ({ groupcastId, searchTag = null, limit = 20, skip = 0 }) => {
  const params = {
    groupcastId: groupcastId,
    limit: limit,
    skip: skip,
  };

  if (searchTag) {
    params.searchTag = searchTag;
  }

  const res = await ChatSDK.getInstance().groupcast.getEligibleMembersForGroupCast(params);
  return res;
};

export const getGroupcastMembers = async ({groupcastId}) => {
  const res = await ChatSDK.getInstance().groupcast.getGroupCastMembers({
    groupcastId: groupcastId,
  });
  return res;
};

export const addGroupcastMember = async (groupcastId, memberIds) => {
  const members = memberIds.map(memberId => ({
    newConversationTypingEvents: true,
    newConversationReadEvents: true,
    newConversationPushNotificationsEvents: true,
    memberId: memberId,
    newConversationMetadata: null,
    newConversationCustomType: null
  }));
  const res = await ChatSDK.getInstance().groupcast.addMembersToGroupCast({
    groupcastId: groupcastId,
    members: members,
  });
  return res;
};

export const removeGroupcastMember = async (groupcastId, members) => {
  const res = await ChatSDK.getInstance().groupcast.removeMemebersFromGroupCast({
    groupcastId: groupcastId,
    members: members,
  });
  return res;
};

export const deleteGroupcastMessageSelf = async ({ groupcastId, messageId, memberId }) => {
  const res = await ChatSDK.getInstance().groupcast.deleteMessageSelf({
    groupcastId: groupcastId,
    messageId: messageId,
    notifyOnCompletion: true,
    deleteForAll: false,
    sendPushForMessageDeleted: true,
    memberIds: memberId,
  });
  return res;
};

export const deleteGroupcastMessageEveryone = async ({ groupcastId, messageId }) => {
  const res = await ChatSDK.getInstance().groupcast.deleteMessageEveryone({
    groupcastId: groupcastId,
    messageId: messageId,
    notifyOnCompletion: true,
    deleteForAll: true,
    sendPushForMessageDeleted: true,
  });
  return res;
};

export const getGroupcastMessageReadStatus = async ({ groupcastId, messageId }) => {
  const res = await ChatSDK.getInstance().groupcast.getGroupCastStatusRead({
    groupcastId: groupcastId,
    groupcastMessageId: messageId,
  });
  return res;
};

export const getGroupcastMessageDeliveryStatus = async ({ groupcastId, messageId }) => {
  const res = await ChatSDK.getInstance().groupcast.getGroupCastStatusDelivery({
    groupcastId: groupcastId,
    groupcastMessageId: messageId,
  });
  return res;
};

export const getPresignedUrlForGroupcastMedia = async ({userIdentifier, mediaExtension}) => {
  const res = await ChatSDK.getInstance().user.getPresignedurlUpdate({
    userIdentifier: userIdentifier,
    mediaExtension: mediaExtension,
  });
  return res;
}